import { Folder, Loader2, Ban } from "lucide-react";

type Props = {
  isLoading: boolean;
  error?: string;
  folders?: string[];
  currentPath?: string;
  sep?: string;
  onFolderClick: (path: string) => void;
};

export const DirectoryList = ({
  isLoading,
  error,
  folders,
  currentPath,
  sep,
  onFolderClick,
}: Props) => {
  if (isLoading) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-2 text-gray-400">
        <Loader2 className="h-6 w-6 animate-spin" />
        <span className="text-[12px]">Loading folders...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-2 text-red-400">
        <Ban className="h-6 w-6" />
        <span className="text-[12px] whitespace-pre-line">{error}</span>
      </div>
    );
  }

  return (
    <ul className="space-y-1">
      {folders?.length === 0 && (
        <li className="p-8 text-center text-[12px] text-gray-400 italic">
          No subfolders found in this directory.
        </li>
      )}
      {folders?.map((folder) => (
        <li key={folder}>
          <button
            type="button"
            onClick={() => onFolderClick(`${currentPath}${sep}${folder}`)}
            className="group flex w-full items-center gap-3 rounded-md px-3 py-2 text-left text-[12px] text-gray-700 transition-colors hover:bg-blue-50 hover:text-blue-700"
          >
            <Folder className="h-4 w-4 fill-blue-50 text-blue-500 group-hover:fill-blue-200" />
            <span className="truncate text-[12px]">{folder}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};
